/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import {clamp} from '@benchling/js-utils';
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';

import {assert} from 'Asserts';

const X_AXIS = 'x';
const Y_AXIS = 'y';

interface Props {
  // Will default to 'left' if not specified
  alignment?: 'left' | 'center' | 'right' | null;
  minWidth: number;
  maxWidth: number;
  setItemWidth: (...args: Array<any>) => any;
  finalizeItemWidth: (...args: Array<any>) => any;
}

type State = any;

class PreviewResizer extends React.Component<Props, State> {
  static defaultProps = {
    minWidth: 100,
  };

  override componentDidMount(): void {
    const parents = '.mediocre-captionEditable-component, .notePartGrid-itemContent';
    this.setState({
      previewDOMNode: $(ReactDOM.findDOMNode(this)!).parents(parents),
    });
  }

  override componentWillUnmount(): void {
    $(window).off('mousemove', this.resizePreview);
    $(window).off('mouseup', this.deactivateResize);
  }

  _convertDimension = (axis: any, value: any): number => {
    const width = $(this.state.previewDOMNode).outerWidth();
    const height = $(this.state.previewDOMNode).outerHeight();
    const ratio = axis === X_AXIS ? height / width : width / height;
    return Math.floor(ratio * value);
  };

  _normalizePos = (pos: number, axis: typeof X_AXIS | typeof Y_AXIS): number => {
    if (axis === Y_AXIS) {
      return pos - this.state.startY + this.state.startHeight;
    } else if (axis === X_AXIS) {
      switch (this.props.alignment) {
        case 'right':
          return this.state.startX - pos + this.state.startWidth;
        default:
          return pos - this.state.startX + this.state.startWidth;
      }
    } else {
      assert(false, 'Invalid axis');
    }
  };

  _calculateWidth = ({pageX, pageY}: {pageX: number; pageY: number}): number => {
    let xPos = this._normalizePos(pageX, X_AXIS);
    const yPos = this._normalizePos(pageY, Y_AXIS);

    // Key off of whichever mouse position results in a bigger preview
    // (since we only support one aspect ratio, we need to pick one of the two axes)
    if (this._convertDimension(X_AXIS, xPos) < yPos) {
      xPos = this._convertDimension(Y_AXIS, yPos);
    }

    return clamp(this.props.minWidth, this.props.maxWidth, xPos);
  };

  activateResize = (e: any): void => {
    e.preventDefault(); // Don't steal focus on click
    this.setState({
      startX: e.pageX,
      startY: e.pageY,
      startWidth: $(this.state.previewDOMNode).outerWidth(),
      startHeight: $(this.state.previewDOMNode).outerHeight(),
    });

    $(window).on('mousemove', this.resizePreview);
    $(window).one('mouseup', this.deactivateResize);
  };

  resizePreview = (e: any): void => {
    this.props.setItemWidth(this._calculateWidth(e));
  };

  deactivateResize = (e: any): void => {
    $(window).off('mousemove', this.resizePreview);
    this.props.finalizeItemWidth(this._calculateWidth(e));
  };

  override render(): JSX.Element {
    return (
      <div
        className={classNames('previewResizer', `is-${this.props.alignment}`)}
        onMouseDown={this.activateResize}
      >
        <div className="previewResizerTarget" />
      </div>
    );
  }
}

export default PreviewResizer;
